<template>
  <div>
    <title-bar-back :title="'添加客服'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>

    <div class="content">
      <img class="qrcode" :src="customerQrcode" alt="" @click="saveImage" />

      <div class="addbtn" @click="saveImage">点击保存图片</div>
    </div>
  </div>
</template>

<script>
import customerQrcode from "@/assets/common/customer_qrcode.png";
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then((m) => m.default || m);
export default {
  name: "customer",
  components: {
    TitleBarBack,
  },
  data() {
    return {
      customerQrcode,
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    saveImage() {
      const link = document.createElement("a");
      link.href = this.customerQrcode;
      link.download = "客服二维码.png";
      link.click();
    },
  },
};
</script>

<style scoped>
.content {
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}

.qrcode {
  width: 220px;
  height: 220px;
}

.addbtn {
  margin-top: 20px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
